import './ListItem.scss'

import classNames from 'classnames'
import React, { MouseEvent, useCallback, useEffect, useState } from 'react'

export interface ListItemProps extends React.ComponentPropsWithoutRef<'li'> {
  onMouseEnter?: (event: MouseEvent) => void
  onMouseLeave?: (event: MouseEvent) => void
  className?: string
  children?: React.ReactNode
  highlight?: boolean
}

export default function ListItem({
  children,
  className,
  onMouseEnter,
  onMouseLeave,
  highlight,
  ...rest
}: ListItemProps): JSX.Element {
  const [highlighted, setHighlighted] = useState<boolean>(false)

  const highlightStyle = {
    backgroundColor: 'var(--hds-background-hover)',
  } as React.CSSProperties

  useEffect(() => {
    setHighlighted(Boolean(highlight))
  }, [highlight])

  const handleMouseEnter = useCallback(
    (event: MouseEvent) => {
      setHighlighted(true)

      onMouseEnter && onMouseEnter(event)
    },
    [onMouseEnter]
  )

  const handleMouseLeave = useCallback(
    (event: MouseEvent) => {
      setHighlighted(false)

      onMouseLeave && onMouseLeave(event)
    },
    [onMouseLeave]
  )

  return (
    <li
      className={classNames('ListItem ListItemContainer', className, {
        ListItemHighlighted: highlighted,
      })}
      style={highlighted ? highlightStyle : undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      {...rest}
    >
      {children}
    </li>
  )
}
